import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Utility function to get the appropriate className for form icons based on error state
 */
export const getFormIconClassName = (hasError: boolean): string =>
  `size-5 ${hasError ? "text-red-500" : "text-primary/70"}`;
